module.exports = __webpack_public_path__ + "media/icons/star-6ad74e15b09c1fbb3ebabb085c616973.svg";